import { render, staticRenderFns } from "./StepTwoForm.vue?vue&type=template&id=13df89b9"
import script from "./StepTwoForm.vue?vue&type=script&lang=ts"
export * from "./StepTwoForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports